export default __webpack_public_path__ + "static/media/prev_arrow.43be2dd7.svg";